/*
 ChatComponent component
 url match: /dashboard
 Base component for the home page, redirects to appropriate 
 components depending on the URL/Route
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Loader from 'react-loader-spinner'
import { chatStyles } from '../../../Styles/chatStyles'
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Switch, Route } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { ReactSVG } from 'react-svg'
import Images from '../../../Theme/Images';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import NewChat from './NewChat';


const chats = [
    {
        name: 'Ticket 1 ',
        id: 'A1234434',
        category: 'Health Insurance',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Vishal Rao',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        source: 'twitter',
        status: 'Pending',
        time: '10:03'


    },
    {
        name: 'Ticket 4 ',
        id: 'B1234434',
        category: 'Claim Status',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Shahab Khan',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Active',
        source: 'whatsappMini',
        time: 'Dec 10'

    },

    {
        name: 'Ticket 3 ',
        id: 'C1224434',
        category: 'Hard Copy Request',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Amit Bhadra',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Pending',
        source: 'whatsappMini',
        time: 'Apr 10'

    },
    {
        name: 'Ticket 4 ',
        id: 'D12wq4434',
        category: 'Claim Status',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Shahab Khan',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Closed',
        source: 'facebook',
        time: 'Apr 10'
    },
    {
        name: 'Ticket 3 ',
        id: 'e123443w',
        category: 'Hard Copy Request',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Amit Bhadra',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Pending',
        source: 'twitter',
        time: 'Apr 10'
    }
    ,
    {
        name: 'Ticket 4 ',
        id: 'D12a4434',
        category: 'Claim Status',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Shahab Khan',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Closed',
        source: 'facebook',
        time: 'Apr 10'
    },
    {
        name: 'Ticket 3 ',
        id: 'e123w434',
        category: 'Hard Copy Request',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Amit Bhadra',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Pending',
        source: 'twitter',
        time: 'Apr 10'
    }
    ,
    {
        name: 'Ticket 4 ',
        id: 'D123s434',
        category: 'Claim Status',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Shahab Khan',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Closed',
        source: 'facebook',
        time: 'Apr 10'
    },
    {
        name: 'Ticket 3 ',
        id: 'e1234w34',
        category: 'Hard Copy Request',
        desc: 'A detailed one liner about the ticket in question  ',
        customer: 'Amit Bhadra',
        agent: 'Farha',
        contact: 'testuser@gmail.com',
        type: 'open',
        status: 'Pending',
        source: 'twitter',
        time: 'Apr 10'
    }

]
@inject('userStore', 'commonStore')
@observer
class ChatComponent extends React.Component {

    state = {
        shrink: false,
        currentChat: {}
    }
    openChat = (item) => {
        this.setState({
            currentChat: item,
            shrink: true
        })
    }

    showListing = () => {
        this.setState({
            shrink: false,
            currentChat: {}
        })
    }

    render() {
        const { classes, theme } = this.props;
        const { activeTab } = this.props.commonStore;
        const { shrink, currentChat } = this.state
        let a = new Date()
        if (this.props.userStore.logoutProgress) {
            return (
                <div className={classes.loaderDiv}>
                    <Loader height={100} width={100} color={this.props.theme.palette.mustard} className={classes.loading} timeout={100000} />
                </div>
            )
        }
        return (
            <div className={classes.listContainer}>
                <div className="colFlex">
                    {
                        chats.map((row, index) => (
                            <Card className={clsx({
                                [classes.chat]: true,
                                [classes.shrinkChat]: shrink,
                            })} style={{ backgroundColor: currentChat.id === row.id ? theme.palette.paleGray : theme.palette.white }}
                                onClick={(e) => this.openChat(row)}
                            >
                                <CardContent className="rowFlex">
                                    <div style={{ width: '100%' }}>
                                        <div className="rowFlex" style={{ justifyContent: 'space-between' }}>
                                            <Typography className={clsx({ [classes.chatHeading]: true, [classes.activeStyle]: currentChat.id === row.id })}>{row.id}</Typography>
                                            <Typography className={clsx({ [classes.detailText]: true, [classes.activeStyle]: currentChat.id === row.id })}>{row.status}</Typography>
                                        </div>
                                        <Typography className={classes.detailText}>{row.category}</Typography>

                                        <div className="rowFlex" style={{ justifyContent: 'space-between' }}>
                                            <div className="rowFlex">
                                                <ReactSVG style={{ marginRight: '8px' }} src={Images[`${row.source}`]} />
                                                <Typography className={clsx({ [classes.detailText]: true })}>{row.customer}</Typography>
                                            </div>
                                            <Typography className={clsx({ [classes.detailText]: true })}>{row.time}</Typography>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        ))
                    }
                </div>
                {shrink ? <NewChat chat={currentChat} goBack={this.showListing} /> : null}

            </div>
        );
    }
}
export default withStyles(chatStyles, { withTheme: true })(withRouter(ChatComponent));
